'use client';
import ChoiceSpecialtyCard from '@/components/ChoiceSpecialty/ChoiceSpecialtyCard';
import { ArrowUpRightIcon } from '@heroicons/react/16/solid';
import React, { ReactNode, useState } from 'react';
import ModalForm from '../Modal/Modal';
import { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';
import CustomRichText from '../CustomRichText';

export interface StudyFormatBlockProps {
  id?: string;
  title?: ReactNode | SerializedEditorState;
  text?: ReactNode | SerializedEditorState;
  subtitle?: ReactNode | SerializedEditorState;
  formatList: Array<{
    title: ReactNode | SerializedEditorState;
    subtitle: ReactNode | SerializedEditorState;
    txtContent: ReactNode | SerializedEditorState;
  }>;
  buttonText: string;
  color?: 'violet' | 'blue' | 'green';
}
export default function ChoiceSpecialtyBlock({
  formatList,
  id,
  title,
  text,
  subtitle,
  buttonText,
  color = 'blue',
}: StudyFormatBlockProps) {
  const [isFormOpen, setIsFormOpen] = useState(false);

  const openForm = () => setIsFormOpen(true);
  const closeForm = () => setIsFormOpen(false);

  const backgroundColorClass =
    {
      green: 'custom-gradient-green-btn',
      blue: 'custom-gradient-blue-btn',
      violet: 'custom-gradient-violet-btn',
    }[color] || 'custom-gradient-green-btn';
  return (
    <>
      <div
        id={id}
        data-meta="ChoiceSpecialtyBlock"
        className="container mx-auto px-4 sm:px-6 lg:px-8 my-24"
      >
        <div className="container mx-auto px-4 py-6 sm:py-4 sm:px-6 lg:px-8">
          <div className="mx-auto text-center">
            <CustomRichText
              data={title}
              tag="h2"
              className="text-3xl font-bold tracking-tight text-white sm:text-6xl mb-4 sm:mb-8"
            />
            <CustomRichText
              data={text}
              tag="div"
              className="mt-6 text-base lg:text-lg md:leading-6 lg:leading-8 text-white"
            />
          </div>
        </div>
        <div className="container mx-auto px-4 py-6 sm:py-4 sm:px-6 lg:px-8">
          <div className="mx-auto text-center">
            <CustomRichText
              data={subtitle}
              tag="div"
              className="text-2xl font-bold tracking-tight text-white mb-4 sm:mb-8"
            />
          </div>
        </div>
        <div className="flex justify-center">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 xl:gap-8 lg:gap-4 gap-4">
            {formatList.map((item, index) => (
              <ChoiceSpecialtyCard
                key={index}
                subtitle={item.subtitle}
                title={item.title}
                txtContent={item.txtContent}
                index={index}
                color={color}
              />
            ))}
            <div className="flex items-center justify-center">
              <button
                onClick={openForm}
                className={`pl-8 pr-1 py-2 text-md h-fit font-bold text-white uppercase rounded-full  ring-${color}-500 ring-1 flex gap-2 items-center leading-8`}
              >
                <span className="max-sm:text-sm">{buttonText}</span>
                <div className={`rounded-full ${backgroundColorClass} p-2`}>
                  <ArrowUpRightIcon className="text-white h-4 w-4" />
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
      {isFormOpen && (
        <ModalForm
          closeForm={closeForm}
          btnMeta={{ tag: 'університет-golden-year' }}
          color={color}
        />
      )}
    </>
  );
}
